import React from 'react'

import { AppSettingsPage } from 'features/AppSettings/AppSettingsPage'

import { Box } from 'ui/components/Box'

import { useAiAppSettingsControlsState } from './hooks/useAiAppSettingsControlsState'
import { ModelSelect } from './ModelSelect'

type AiAppSettingsControlsProps = {}

export const AiAppSettingsControls: React.FC<AiAppSettingsControlsProps> = () => {
    const { currentDefaultModel, onChangeDefaultModel } = useAiAppSettingsControlsState()

    return (
        <AppSettingsPage title="AI">
            <Box>
                <ModelSelect
                    label="Default model"
                    defaultModelLabel="Latest"
                    style={{ width: 'auto' }}
                    value={currentDefaultModel}
                    onChange={onChangeDefaultModel}
                />
            </Box>
        </AppSettingsPage>
    )
}
